import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_light_indicator_component = _resolveComponent("light-indicator-component")
  const _component_cookies_button = _resolveComponent("cookies-button")

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_cookies_button, { onClick: _ctx.handleClick }, {
      default: _withCtx(() => [
        _createElementVNode("span", { style: {"font-size":"3rem","font-weight":"900"} }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.button.turnsOnLights, (id) => {
            return (_openBlock(), _createBlock(_component_light_indicator_component, {
              id: id,
              "turns-on": true
            }, null, 8 /* PROPS */, ["id"]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.button.turnsOffLights, (id) => {
            return (_openBlock(), _createBlock(_component_light_indicator_component, {
              id: id,
              "turns-on": false
            }, null, 8 /* PROPS */, ["id"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}